import { CreatePostPayload } from "@/app/post-internal-chats/post-internal-chats.api";

export const toYMD = (d?: Date | string) =>
    d ? new Date(d).toISOString().split("T")[0] : undefined;

export const buildCreatePostPayload = (
    v: any,
    branchId: number
): CreatePostPayload => {
    const p: Partial<CreatePostPayload> = {
        /* obligatorios */
        branch_id: branchId,
        title: v.title,
        html_design: v.richValue,
        sender_id: v.from?.id,
        send: v.send,
        state: v.state,

        /* filtros generales */
        sex: (v.gender?.map((o: any) => o.name).join(', ')) ?? '',
        age:
            v.min_age || v.max_age ? [v.min_age ?? 0, v.max_age ?? 0] : undefined,

        nutrition_plan: v.nutrition_plan?.map((o: any) => o.name) ?? [],
        training_plan: v.training_plan?.map((o: any) => o.name) ?? [],
        type_estetica_nutrition:
            v.type_estetica_nutrition?.map((o: any) => o.name) ?? [],

        /* disparadores */
        trigger_condition: v.trigger_type?.id,
        trigger: v.sending?.id,
        frequency: v.frequency?.id,
        days: v.selected_days?.length ? v.selected_days : undefined,

        /* rango fechas y hora */
        date_init: toYMD(v.date_start),
        date_finish: toYMD(v.date_end),
        time: v.hour ? `${v.hour}:00` : undefined,

        /* evento */
        type_event: v.event_type?.id,
        group_event: v.groups?.map((g: any) => g.name) ?? [],
        coach_event: v.specialists?.map((s: any) => s.id) ?? [],
        category_event: v.categories?.map((c: any) => c.id) ?? [],

        /* condicionales */
        nro_day_assistance:
            v.event_type?.id === 4 ? Number(v.nro_day_assistance) : undefined,
        nro_days_payment:
            v.event_type?.id === 5 ? Number(v.nro_days_payment) : undefined,
        repetitions: v.frequency?.id === 3 ? Number(v.repetitions) : undefined,

        bonds:v.event_type?.id === 8 ? v.bonds?.map((o: any) => o.id): [],
        slotsBonds:v.event_type?.id === 8 ? v.slotsBonds?.map((o: any) => o.id): [],
        number_days:v.number_days?.name,
    };

    /* limpia null / undefined antes de enviar */
    return Object.fromEntries(
        Object.entries(p).filter(([, v]) => v != null)
    ) as CreatePostPayload;
};
